import React from 'react'

import { Button, Icon } from 'src/chrome'

import styles from './banner.module.scss'
import { Item } from 'src/campaign_store/types'
import { Div, Spacer, Text } from '@sendoutcards/quantum-design-ui'

interface Props {
  backgroundStartColor: string
  backgroundEndColor: string
  image?: string
  onClose?: () => void
  onPurchase: (product: Item) => void
  product?: Item
  isCategorySelected: boolean
  textColor: string
  title: string
}

const Banner: React.FC<Props> = props => {
  const {
    backgroundStartColor,
    backgroundEndColor,
    image,
    onClose,
    onPurchase,
    product,
    isCategorySelected,
    textColor,
    title,
  } = props
  return (
    <div className={styles.reasonToSend} style={{ position: 'relative' }}>
      {isCategorySelected && (
        <div className={styles.closeCollection} onClick={() => onClose?.()}>
          <Icon icon={'ARROWLEFT'} size={18} color={textColor} />
          <Div display="inline-block" outset={{ left: 'x1' }}>
            <Text type="caption" color="accent">
              Back
            </Text>
          </Div>
        </div>
      )}
      <div
        className={styles.reasonBackground}
        style={{
          backgroundImage: `linear-gradient(115deg, ${backgroundStartColor}, ${backgroundEndColor})`,
        }}
      >
        <div className={styles.featureContent}>
          {image && <img src={image} className={styles.image} alt={title} />}
          <div className={styles.reason}>
            <Text type="title" color="accent">
              {title}
            </Text>
            {!isCategorySelected && (
              <div>
                <Spacer space="x2" />
                <Div maxWidth="600px">
                  <Text type="body" color="accent">
                    {product?.description}
                  </Text>
                </Div>
                <Spacer space="x4" />
                <div style={{ display: 'flex', alignItems: 'center' }}>
                  <Text type="body" weight="bold" color="accent">
                    {product?.price}
                  </Text>
                  <Button
                    titleStyle={{
                      color: '#fff',
                    }}
                    style={{
                      marginLeft: 15,
                      border: `1px solid ${textColor ? textColor : '#FFF'}`,
                      background: 'transparent',
                    }}
                    innerStyle={{
                      background: 'transparent',
                    }}
                    title={'Purchase'}
                    onClick={() => product && onPurchase(product)}
                  />
                </div>
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
  )
}

export default Banner
